<template>
<div class="size margin">

  <div class="example">
    <titleComponent value="Colors" mark="01" color="background-green" />

    <div class="container wrap">


      <div class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="box-item-colors text-center background-red color-white container align-center">
          <div class="text container column">
            <strong>color-red</strong>
            <strong>background-red</strong>
            <p><small>#C2003C</small></p>
          </div>
        </div>
      </div>


      <div class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="box-item-colors text-center background-blue color-white container align-center">
          <div class="text container column">
            <strong>color-blue</strong>
            <strong>background-blue</strong>
            <p><small>#3BBFD4</small></p>
          </div>
        </div>
      </div>


      <div class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="box-item-colors text-center background-green color-white container align-center">
          <div class="text container column">
            <strong>color-green</strong>
            <strong>background-green</strong>
            <p><small>#5EC12D</small></p>
          </div>
        </div>
      </div>


      <div class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="box-item-colors text-center background-yellow color-white container align-center">
          <div class="text container column">
            <strong>color-yellow</strong>
            <strong>background-yellow</strong>
            <p><small>#FF9C00</small></p>
          </div>
        </div>
      </div>

      <div class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="box-item-colors text-center background-dark color-white container align-center">
          <div class="text container column">
            <strong>color-dark</strong>
            <strong>background-dark</strong>
            <p><small>#413F3F</small></p>
          </div>
        </div>
      </div>

      <div class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="box-item-colors text-center background-dark-grey color-white container align-center">
          <div class="text container column">
            <strong>color-dark-grey</strong>
            <strong>background-dark-grey</strong>
            <p><small>#6F6F6F</small></p>
          </div>
        </div>
      </div>

      <div class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="box-item-colors text-center background-grey color-dark container align-center">
          <div class="text container column">
            <strong>color-grey</strong>
            <strong>background-grey</strong>
            <p><small>#D5D5D5</small></p>
          </div>
        </div>
      </div>

      <div class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
        <div class="box-item-colors text-center background-white color-dark container align-center">
          <div class="text container column">
            <strong>color-white</strong>
            <strong>background-white</strong>
            <p><small>#ffffff</small></p>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="example">
      <titleComponent value="Gradients" mark="01" color="background-blue" />

      <div class="container wrap text-center">

        <div v-for="x in gradients" class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
          <div class="box-item-colors text-center container align-center" :class="x.class">
            <div class="container wrap">
            </div>
          </div>
          <!-- <small>{{x.name}}</small> -->
        </div>

      </div>

      <div class="margin-left-20 margin-top-20">
        <h4>Special gradients</h4>
      </div>
      <div class="container text-center wrap">
        <div v-for="x in newGradients" class="box-colors col-6 col-sm-6 col-md-4 col-lg-3">
          <div class="box-item-colors text-center container align-center" :class="x.class">
            <div class="container wrap">
            </div>
          </div>
          <!-- <small>{{x.name}}</small> -->
        </div>
      </div>
    </div>

  <!-- <div class="example">
      <titleComponent value="Shadows" mark="01" color="background-red" />
      <div class="container wrap">
        <div class="box-shadow text-center container justify-content-center align-items-center" v-for="x in shadows" :class="x.class">
          <div class="text container column">
            <strong>{{x.name}}</strong>
          </div>
        </div>
      </div>
    </div> -->

</div>
</template>

<script>
import titleComponent from '@/components/titleComponent'

export default {
  name: 'colors',
  components: {
    titleComponent
  },
  data () {
    return {
      shadows: [{
        name: 'Shadow-small',
        class: 'shadow-small'
      }, {
        name: 'Shadow-medium',
        class: 'shadow-medium'
      }, {
        name: 'Shadow-large',
        class: 'shadow-large'
      }, {
        name: 'Shadow-box',
        class: 'shadow-box'
      }],
      gradients: [{
        name: 'Grandient-red',
        color: '#F5515F',
        color2: '#9F041B',
        class: 'gradient-red'
      }, {
        name: 'Gradient-blue',
        color: '#00FFDA',
        color2: '#06355D',
        class: 'gradient-blue'
      }, {
        name: 'Gradient-yellow',
        color: '#FAD961',
        color2: '#F76B1C',
        class: 'gradient-yellow'
      }, {
        name: 'Gradient-green',
        color: '#B4EC51',
        color2: '#429321',
        class: 'gradient-green'
      }, {
        name: 'Gradient-purple',
        color: '#3023AE',
        color2: '#C86DD7',
        class: 'gradient-purple'
      }],
      newGradients: [{
        name: 'Gradient-1',
        class: 'gradient-1'
      }, {
        name: 'Gradient-2',
        class: 'gradient-2'
      }, {
        name: 'Gradient-3',
        class: 'gradient-3'
      }, {
        name: 'Gradient-4',
        class: 'gradient-4'
      }, {
        name: 'Gradient-5',
        class: 'gradient-5'
      }, {
        name: 'Gradient-6',
        class: 'gradient-6'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/css/base/variables.scss";
.box-colors {
    padding: 10px;
    box-sizing: border-box;
    text-transform: uppercase;

    .box-item-colors {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
        box-sizing: border-box;
        transition: 0.3s;
        min-height: 200px;
        cursor: pointer;
        border-radius: $radius;
        &:hover {
            box-shadow: 0 10px 10px 0 rgba(0, 0, 0, .1);
            transform: translateY(-10px);
        }
    }

    p {
        font-size: 2rem;
        opacity: 0.5;
    }
    strong {
        display: none;
    }
}

.box-shadow {
    &:hover {
        transform: translateY(-10px);
    }
}

.box-gradient {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    color: #fff;
    transition: 0.3s;
    cursor: pointer;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
    &:hover {
        box-shadow: 0 10px 10px 0 rgba(0, 0, 0, .1);
        transform: translateY(-10px);
    }
}

.ball-gradients {
    margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/styleguide/colors.vue